import Vue from 'vue'
// import _ from 'lodash'

export default async () => {
  const res = await Vue.axios.get(`/billing/products?name=DISK SSD&per_page=9999`)
  return res.data.products
}



// WEBPACK FOOTER //
// ./src/services/billing/fetch-disk-ssd.js